const ISLIVE = process.env.REACT_APP_IS_LIVE

export const BaseUrls: any = {
	API_SERVER: {
		url: ISLIVE ? process.env.REACT_APP_API_BASE_URL_LIVE : process.env.REACT_APP_API_BASE_URL_UAT
	},
}